exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".station[data-v-474921c8] .edui-editor-iframeholder{height:300px !important}.station[data-v-474921c8] .el-textarea__inner{height:120px;resize:none}.station[data-v-474921c8] .el-drawer__body{padding:20px 20px 50px 20px}.button[data-v-474921c8] .el-button{line-height:0.3}[data-v-474921c8] .tips{font-size:13px;color:#999;margin-bottom:20px;margin-left:75px}.dialog-footer[data-v-474921c8]{padding-top:20px;border-top:1px solid #e6ebf5;text-align:right}[data-v-474921c8] .el-cascader{width:100%}\n", ""]);

// exports
